import React, { Component } from 'react'
import { injectIntl } from 'react-intl'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import { Button } from 'antd'
import BunkeyAPI from '../../api/BunkeyAPI'
import { Table, Row, Col, Icon, Popconfirm, Tooltip, Select, Input } from 'antd'
import { sendNotification } from '../../utils/index'
import moment from 'moment'

const Option = Select.Option

export class List extends Component {

  constructor(props) {
    super(props)

    this.state = {
      isFetching: true,
      data: [],
      limit: 10,
      count: 1,
      activePage: 1,
      columns: null
    }
  }

  componentDidMount() {
    const urlParams = new URLSearchParams(this.props.location.search)
    const status = urlParams.get('status')
    const { intl } = this.props

    if (status === 'success') {
      sendNotification('success', intl, 'El post ha sido creado.')
    }
    this.handleGetData()
    this.handleCreateColumns()
  }

  handleCreateColumns = () => {
    this.setState({
      columns: [{
        title: 'Título',
        dataIndex: 'title',
      }, {
        title: 'Categoría',
        dataIndex: 'category',
      }, {
        title: 'Cant. Visitas',
        dataIndex: 'viewCount',
      }, {
        title: '¿Es fijo?',
        dataIndex: 'fixed',
      }, {
        title: 'F. Creación',
        dataIndex: 'createdAt',
      }, {
        title: 'Opciones',
        dataIndex: '',
        key: 'options',
        render:
          record =>
            <React.Fragment>
              <Tooltip placement="top" title="Editar"><button style={{ margin: '0 10px' }}><Icon type="edit" /></button></Tooltip>
              <Popconfirm title="¿Realmente deseas eliminar registro?" onConfirm={() => { this.handleDelete(record) }} okText="Sí" cancelText="No">
                <Tooltip placement="top" title="Eliminar"><button><Icon type="delete" /></button></Tooltip>
              </Popconfirm>
            </React.Fragment>,
      }]
    })
  }

  handleSee = (value) => {
    this.props.history.push(`/manager/cms/${value._id}`)
  }

  handleDelete = (value) => {
    const { intl } = this.props

    BunkeyAPI({
      url: `/cms/manager/posts/${value._id}`,
      method: 'DELETE',
    }).then(resp => {
      if (resp && resp.status === 204) {
        sendNotification('success', intl, 'El post ha sido eliminado')
        this.handleGetData()
      }
    }).catch(err => {
      sendNotification('error', intl, 'No se ha podido eliminar, intenta nuevamente')
    })
  }

  handleGetData = () => {
    const { activePage } = this.state

    this.setState({
      isFetching: true
    }, () => {
      BunkeyAPI({
        url: `/cms/manager/posts?page=${activePage}`,
        method: 'GET',
      }).then(resp => {
        if (resp.data && resp.data.length > 0) {
          this.setState({
            isFetching: false,
            data: resp.data.map((r, k) => {
              return {
                ...r,
                title: r.title.substring(0, 30) + '...',
                fixed: r.fixed ? 'Sí' : 'No',
                createdAt: moment(r.createdAt).format("DD/MM/YYYY HH:mm:ss") + ' hrs'
              }
            }),
            limit: parseInt(resp.headers['x-pagination-limit']),
            count: parseInt(resp.headers['x-pagination-total-count']),
          })
        } else {
          this.setState({
            isFetching: false,
            data: []
          })
        }
      }).catch(err => {
        this.setState({
          isFetching: false,
          data: []
        })
      })
    })
  }

  onChangePage = (page) => {
    this.setState({
      activePage: page,
    }, () => {
      this.handleGetData()
    })
  }

  render() {
    const { isFetching, data, limit, count, activePage, columns } = this.state

    return (
      <React.Fragment>
        <div className="title-bar">
          <div className="container">
            <span>Listado</span>
            <div style={{
              display: 'block',
              float: 'right',
              marginRight: 15,
              marginTop: 10
            }}>
              <button onClick={() => this.props.history.push('/manager/create')} className="ant-btn ant-btn-primary">Nuevo</button>
            </div>
          </div>
        </div>
        <div className="assets-wrapper">
          <div className="container">
            <Row style={{ padding: '0 24px' }}>
              <Col span={8}>
                <Input placeholder="Título" />
              </Col>
              <Col span={8} style={{ paddingLeft: 20 }}>
                <Select placeholder="Categoría" style={{ width: 200 }}>
                  <Option value="dam">DAM´S</Option>
                  <Option value="marketing">Marketing</Option>
                  <Option value="bunkey">Bunkey</Option>
                </Select>
                <Select placeholder="¿Es Fijo?" style={{ marginLeft: 20, width: 100 }}>
                  <Option value="fixed">Sí</Option>
                  <Option value="unfixed">No</Option>
                </Select>
              </Col>
              <Col span={8} style={{ paddingLeft: 20 }}>

                <Button icon="search" style={{ marginLeft: 20 }}>Buscar</Button>
              </Col>
            </Row>
            <Row>
              <Col>
                <Table
                  bordered
                  loading={isFetching}
                  className="selector-client-table"
                  rowKey='_id'
                  columns={columns}
                  dataSource={data}
                  pagination={{
                    current: activePage,
                    pageSize: limit,
                    total: count,
                    onChange: this.onChangePage
                  }}
                />
              </Col>
            </Row>
          </div>
        </div>
      </React.Fragment>)
  }
}

const mapStateToProps = (state) => ({

})

const mapDispatchToProps = {

}

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(List)))